import React from "react";
import Loadable from "react-loadable";
import { URL } from "./paths";

function Loading() {
  return <div>Loading...</div>;
}

function HomePage() {
  return (
    <div style={{ textAlign: "center", lineHeight: 30, fontSize: "32px" }}>
      Home page
    </div>
  );
}

const CreateTravelExpense = Loadable({
  loader: () => import("../views/CreateTravelExpense/CreateTravelExpenseView"),
  loading: Loading
});

const GetTravelExpense = Loadable({
  loader: () => import("../views/GetTravelExpense/GetTravelExpenseView"),
  loading: Loading
});

const EditTravelExpense = Loadable({
  loader: () => import("../views/EditTravelExpense/EditTravelExpenseView"),
  loading: Loading
});

const UserRolePage = Loadable({
  loader: () => import("../views/UserRole/UserRoleView"),
  loading: Loading
});

const ReportsPage = Loadable({
  loader: () => import("../views/Reporting/ReportingView"),
  loading: Loading
});

const routes = [
  {
    path: URL.homePage,
    exact: true,
    name: "Home",
    component: HomePage,
    private: false
  },
  {
    path: URL.createTravelExpense,
    name: "Create Travel Expense",
    component: CreateTravelExpense,
    private: true
  },
  {
    path: URL.editTravelExpense,
    name: "Edit Travel Expenses",
    component: EditTravelExpense,
    private: true
  },
  {
    path: URL.getTravelExpense,
    name: "Get Travel Expenses",
    component: GetTravelExpense,
    private: true
  },
  {
    path: URL.userRole,
    name: "User roles",
    component: UserRolePage,
    private: true
  },
  {
    path: URL.reports,
    name: "Reports",
    component: ReportsPage,
    private: true
  }
];

export default routes;
